import { site } from "@/data/default";
import { Category } from "@/types/category";
import { contents } from "@/data/categories/contents";

const categories: Category[] = [
  {
    id: 1,
    name: "Laptop",
    title: "Sewa Laptop Terdekat Terlengkap Bergaransi.",
    description: "Pusat Rental Laptop Terdekat Terbaik & Terlengkap untuk Kantor, Event & Sekolah. Durasi Rental ✓ Harian ✓ Mingguan ✓ Bulanan. Langsung Antar ke Lokasi Anda di Jabodetabek",
    url: "/sewa-laptop",
    newTab: false,
    img: {
      src: "/images/categories/sewa-laptop.webp",
      alt: "Tempat Sewa Laptop Terpercaya dengan Pilihan Terlengkap",
      width: 128,
      height: 128,
    },
    featuredImg: {
      src: "/images/featured/sewa-laptop.webp",
      alt: "Tempat Sewa Laptop Terpercaya dengan Pilihan Terlengkap",
      width: 1200,
      height: 630,
    },
    content: contents['laptop'] || <p>Konten belum tersedia</p>,
  },
  {
    id: 2,
    name: "Komputer",
    title: "Sewa Komputer PC Desktop Terdekat Terlengkap Bergaransi.",
    description: "Sewa Komputer PC Desktop Berkualitas untuk Kantor, Event, dan Sekolah. Durasi Rental ✓ Harian ✓ Mingguan ✓ Bulanan. Langsung Antar ke Lokasi Anda di Jabodetabek",
    url: "/sewa-komputer",
    newTab: false,
    img: {
      src: "/images/categories/sewa-komputer.webp",
      alt: "Penyewaan Komputer Berkualitas dengan Harga Terjangkau",
      width: 128,
      height: 128,
    },
    featuredImg: {
      src: "/images/featured/sewa-komputer.webp",
      alt: "Penyewaan Komputer Berkualitas dengan Harga Terjangkau",
      width: 1200,
      height: 630,
    },
    content: contents['komputer'] || <p>Konten belum tersedia</p>,
  },
  {
    id: 3,
    name: "Server",
    title: "Sewa Server Terdekat Terlengkap Bergaransi.",
    description: "Penyewaan Server Berkualitas untuk Kantor, Event, dan Proyek. Durasi Rental ✓ Harian ✓ Mingguan ✓ Bulanan. Langsung Antar ke Lokasi Anda di Jabodetabek",
    url: "/sewa-server",
    newTab: false,
    img: {
      src: "/images/categories/sewa-server.webp",
      alt: "Rental Server Profesional untuk Perusahaan dan Data Center",
      width: 128,
      height: 128,
    },
    featuredImg: {
      src: "/images/featured/sewa-server.webp",
      alt: "Rental Server Profesional untuk Perusahaan dan Data Center",
      width: 1200,
      height: 630,
    },
    content: contents['server'] || <p>Konten belum tersedia</p>,
  },
  {
    id: 4,
    name: "Printer",
    title: "Sewa Printer Terdekat Terlengkap Bergaransi.",
    description: "Penyewaan Printer Berkualitas untuk Kantor, Event, dan Proyek. Durasi Rental ✓ Harian ✓ Mingguan ✓ Bulanan. Langsung Antar ke Lokasi Anda di Jabodetabek",
    url: "/sewa-printer",
    newTab: false,
    img: {
      src: "/images/categories/sewa-printer.webp",
      alt: "Supplier Printer untuk Disewa dengan Beragam Pilihan",
      width: 128,
      height: 128,
    },
    featuredImg: {
      src: "/images/featured/sewa-printer.webp",
      alt: "Supplier Printer untuk Disewa dengan Beragam Pilihan",
      width: 1200,
      height: 630,
    },
    content: contents['printer'] || <p>Konten belum tersedia</p>,
  },
  {
    id: 5,
    name: "Kamera",
    title: "Sewa Kamera Terdekat Terlengkap Bergaransi.",
    description: "Penyewaan Kamera Berkualitas untuk Acara, Shooting, dan Dokumentasi. Durasi Rental ✓ Harian ✓ Mingguan ✓ Bulanan. Langsung Antar ke Lokasi Anda di Jabodetabek",
    url: "/sewa-kamera",
    newTab: false,
    img: {
      src: "/images/categories/sewa-kamera.webp",
      alt: "Harga Sewa Kamera untuk Acara, Shooting, dan Dokumentasi",
      width: 128,
      height: 128,
    },
    featuredImg: {
      src: "/images/featured/sewa-kamera.webp",
      alt: "Harga Sewa Kamera untuk Acara, Shooting, dan Dokumentasi",
      width: 1200,
      height: 630,
    },
    content: contents['kamera'] || <p>Konten belum tersedia</p>,
  },
  {
    id: 7,
    name: "Smart TV",
    title: "Sewa Smart TV Terdekat Terlengkap Bergaransi.",
    description: "Penyewaan Smart TV Berkualitas untuk Acara, Pameran, dan Presentasi. Durasi Rental ✓ Harian ✓ Mingguan ✓ Bulanan. Langsung Antar ke Lokasi Anda di Jabodetabek",
    url: "/sewa-tv-led",
    newTab: false,
    img: {
      src: "/images/categories/sewa-tv-led.webp",
      alt: "Tempat Penyedia Smart TV untuk Event, Pameran, dan Presentasi",
      width: 128,
      height: 128,
    },
    featuredImg: {
      src: "/images/featured/sewa-tv-led.webp",
      alt: "Tempat Penyedia Smart TV untuk Event, Pameran, dan Presentasi",
      width: 1200,
      height: 630,
    },
    content: contents['tv'] || <p>Konten belum tersedia</p>,
  },
  {
    id: 8,
    name: "Videotron",
    title: "Sewa Videotron: LED Indoor/Outdoor Terdekat Terlengkap Bergaransi.",
    description: "Penyewaan Videotron Berkualitas untuk Acara, Pameran, dan Presentasi. Durasi Rental ✓ Harian ✓ Mingguan ✓ Bulanan. Langsung Antar ke Lokasi Anda di Jabodetabek",
    url: "/sewa-videotron",
    newTab: false,
    img: {
      src: "/images/categories/sewa-videotron.webp",
      alt: "Jasa Rental Videotron Indoor dan Outdoor Skala Besar",
      width: 128,
      height: 128,
    },
    featuredImg: {
      src: "/images/featured/sewa-videotron.webp",
      alt: "Jasa Rental Videotron Indoor dan Outdoor Skala Besar",
      width: 1200,
      height: 630,
    },
    content: contents['videotron'] || <p>Konten belum tersedia</p>,
  },
  {
    id: 9,
    name: "Proyektor",
    title: "Sewa Proyektor: Indoor & Outdoor Terdekat Terlengkap Bergaransi.",
    description: "Penyewaan Proyektor Berkualitas untuk Acara, Pameran, dan Presentasi. Durasi Rental ✓ Harian ✓ Mingguan ✓ Bulanan. Langsung Antar ke Lokasi Anda di Jabodetabek",
    url: "/sewa-proyektor",
    newTab: false,
    img: {
      src: "/images/categories/sewa-proyektor.webp",
      alt: "Peminjaman Proyektor untuk Meeting, Seminar, dan Event",
      width: 128,
      height: 128,
    },
    featuredImg: {
      src: "/images/featured/sewa-proyektor.webp",
      alt: "Peminjaman Proyektor untuk Meeting, Seminar, dan Event",
      width: 1200,
      height: 630,
    },
    content: contents['projector'] || <p>Konten belum tersedia</p>,
  },
  {
    id: 11,
    name: "Sound System",
    title: "Sewa Sound System Terdekat Terlengkap Bergaransi.",
    description: "Penyewaan Sound System Berkualitas untuk Acara, Wedding, dan Konser. Durasi Rental ✓ Harian ✓ Mingguan ✓ Bulanan. Langsung Antar ke Lokasi Anda di Jabodetabek",
    url: "/sewa-sound-system",
    newTab: false,
    img: {
      src: "/images/categories/sewa-sound-system.webp",
      alt: "Distributor Penyedia Sound System untuk Event, Wedding, dan Konser",
      width: 128,
      height: 128,
    },
    featuredImg: {
      src: "/images/featured/sewa-sound-system.webp",
      alt: "Distributor Penyedia Sound System untuk Event, Wedding, dan Konser",
      width: 1200,
      height: 630,
    },
    content: contents['soundSystem'] || <p>Konten belum tersedia</p>,
  },
  {
    id: 12,
    name: "Genset",
    title: "Sewa Genset Listrik Terdekat Terlengkap Bergaransi.",
    description: "Penyewaan Genset Berkualitas untuk Acara, Event, dan Kebutuhan Listrik Cadangan. Durasi Rental ✓ Harian ✓ Mingguan ✓ Bulanan. Langsung Antar ke Lokasi Anda di Jabodetabek",
    url: "/sewa-genset",
    newTab: false,
    img: {
      src: "/images/categories/sewa-genset.webp",
      alt: "Layanan Genset Untuk Acara dan Kebutuhan Daya Cadangan",
      width: 128,
      height: 128,
    },
    featuredImg: {
      src: "/images/featured/sewa-genset.webp",
      alt: "Layanan Genset Untuk Acara dan Kebutuhan Daya Cadangan",
      width: 1200,
      height: 630,
    },
    content: contents['genset'] || <p>Konten belum tersedia</p>,
  },
  {
    id: 14,
    name: "Tablet",
    title: "Sewa Tablet & iPad Terdekat Terlengkap Bergaransi.",
    description: "Penyewaan Tablet Berkualitas untuk Acara, Bisnis, dan Kebutuhan Digital. Durasi Rental ✓ Harian ✓ Mingguan ✓ Bulanan. Langsung Antar ke Lokasi Anda di Jabodetabek",
    url: "/sewa-tablet",
    newTab: false,
    img: {
      src: "/images/categories/sewa-tablet.webp",
      alt: "Tablet Android & iPad Tersedia untuk Disewa Acara & Bisnis",
      width: 128,
      height: 128,
    },
    featuredImg: {
      src: "/images/featured/sewa-tablet.webp",
      alt: "Tablet Android & iPad Tersedia untuk Disewa Acara & Bisnis",
      width: 1200,
      height: 630,
    },
    content: contents['tablet'] || <p>Konten belum tersedia</p>,
  },
  {
    id: 15,
    name: "CCTV",
    title: "Sewa CCTV Lengkap Terdekat Terlengkap Bergaransi.",
    description: "Penyewaan CCTV Berkualitas untuk Keamanan dan Surveilans. Durasi Rental ✓ Harian ✓ Mingguan ✓ Bulanan. Langsung Antar ke Lokasi Anda di Jabodetabek",
    url: "/sewa-cctv",
    newTab: false,
    img: {
      src: "/images/categories/sewa-cctv.webp",
      alt: "CCTV untuk Disewa demi Keamanan Event dan Proyek Anda",
      width: 128,
      height: 128,
    },
    featuredImg: {
      src: "/images/featured/sewa-cctv.webp",
      alt: "CCTV untuk Disewa demi Keamanan Event dan Proyek Anda",
      width: 1200,
      height: 630,
    },
    content: contents['cctv'] || <p>Konten belum tersedia</p>,
  },
  {
    id: 16,
    name: "Lighting",
    title: "Sewa Lighting Panggung & Studio Terdekat Terlengkap Bergaransi.",
    description: "Penyewaan Lighting Berkualitas untuk Acara, Event, dan Presentasi. Durasi Rental ✓ Harian ✓ Mingguan ✓ Bulanan. Langsung Antar ke Lokasi Anda di Jabodetabek",
    url: "/sewa-lighting",
    newTab: false,
    img: {
      src: "/images/categories/sewa-lighting.webp",
      alt: "Lighting Show & Dekorasi Pencahayaan untuk Acara Anda",
      width: 128,
      height: 128,
    },
    featuredImg: {
      src: "/images/featured/sewa-lighting.webp",
      alt: "Lighting Show & Dekorasi Pencahayaan untuk Acara Anda",
      width: 1200,
      height: 630,
    },
    content: contents['lighting'] || <p>Konten belum tersedia</p>,
  },
  {
    id: 18,
    name: "Custom",
    title: "Sewa Perangkat Terdekat Terlengkap Bergaransi.",
    description: "Penyewaan Perangkat Berkualitas untuk Kebutuhan Khusus Anda. Durasi Rental ✓ Harian ✓ Mingguan ✓ Bulanan. Langsung Antar ke Lokasi Anda di Jabodetabek",
    url: "/sewa-custom",
    newTab: false,
    img: {
      src: "/images/categories/sewa-custom.webp",
      alt: "Solusi Perangkat Custom Sesuai Permintaan Anda",
      width: 128,
      height: 128,
    },
    featuredImg: {
      src: "/images/featured/sewa-custom.webp",
      alt: "Solusi Perangkat Custom Sesuai Permintaan Anda",
      width: 1200,
      height: 630,
    },
    content: contents['custom'] || <div><h2 className="text-xl font-bold mb-2">Rental Perangkat Khusus terdekat - Jabodetabek • Fleksibel • Langsung Antar, Siap Pakai!</h2><p>Penyewaan Perangkat Berkualitas untuk Kebutuhan Khusus Anda. Durasi Rental ✓ Harian ✓ Mingguan ✓ Bulanan. Langsung Antar ke Lokasi Anda di Jabodetabek</p></div>,
  },
];

export default categories;